import React from "react";

import { Box, Typography } from "@mui/material";
import { IInterests } from "store/types/user/social";

import { InterestIcon } from "./InterestIcon";

interface IInterestsProps {
  data: IInterests[];
}

export const Interests: React.FC<IInterestsProps> = ({ data }) => {
  if (!data.length) return null;

  return (
    <Box sx={{ width: "100%", backgroundColor: "#fff", borderRadius: "8px", padding: "22px" }}>
      <Typography sx={{ marginBottom: "17px", color: "#0a3142", fontWeight: "bold" }}>
        Philanthropic Interests
      </Typography>
      {data.map((item) => (
        <Box key={item.id} sx={{ width: "100%", display: "flex", alignItems: "center", marginBottom: "15px" }}>
          <InterestIcon type={item.icon} />
          <Box sx={{ marginLeft: "20px" }}>
            <Box sx={{ fontSize: "15px", color: "#0a3142" }}>{item.title}</Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};
